import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { useToast } from '../../../../../components/common/Toast';
import { useAccessTheme } from '../useAccessTheme';
import IdentityProviderModalShell from './IdentityProviderModalShell';
import { DEMO_SETUP_MESSAGE } from './identityProviderTypes';

interface OidcSetupModalProps {
  onClose: () => void;
}

const OidcSetupModal: React.FC<OidcSetupModalProps> = ({ onClose }) => {
  const t = useAccessTheme();
  const { showToast } = useToast();
  const [form, setForm] = useState({
    providerName: '',
    issuerUrl: '',
    clientId: '',
    clientSecret: '',
  });

  const labelCls = 'block text-xs font-medium mb-1 ' + t.muted;
  const inputCls = 'w-full border rounded-lg px-3 py-2 text-sm outline-none ' + t.input;

  return (
    <IdentityProviderModalShell
      title="Configure OpenID Connect"
      icon={<KeyRound className="w-5 h-5" />}
      onClose={onClose}
      footer={
        <button
          type="button"
          onClick={() => showToast({ type: 'info', message: DEMO_SETUP_MESSAGE })}
          className={'px-4 py-2 rounded-lg text-sm font-medium ' + t.btnPrimary}
        >
          Save Configuration
        </button>
      }
    >
      <div>
        <label className={labelCls}>Provider Name</label>
        <input
          type="text"
          value={form.providerName}
          onChange={(e) => setForm((prev) => ({ ...prev, providerName: e.target.value }))}
          className={inputCls}
          placeholder="e.g. Corporate SSO"
        />
      </div>
      <div>
        <label className={labelCls}>Issuer URL</label>
        <input
          type="text"
          value={form.issuerUrl}
          onChange={(e) => setForm((prev) => ({ ...prev, issuerUrl: e.target.value }))}
          className={inputCls}
          placeholder="https://idp.example.com"
        />
      </div>
      <div>
        <label className={labelCls}>Client ID</label>
        <input
          type="text"
          value={form.clientId}
          onChange={(e) => setForm((prev) => ({ ...prev, clientId: e.target.value }))}
          className={inputCls}
          placeholder="Client ID"
        />
      </div>
      <div>
        <label className={labelCls}>Client Secret</label>
        <input
          type="password"
          value={form.clientSecret}
          onChange={(e) => setForm((prev) => ({ ...prev, clientSecret: e.target.value }))}
          className={inputCls}
          placeholder="Client secret"
        />
      </div>
    </IdentityProviderModalShell>
  );
};

export default OidcSetupModal;
